@if (selectedBill) {
  <div>
    @if (bills.length > 0 && billManagementTab != 'active') {
      <div class="choice-bill-concerned-area">
        <div class="bill-header" (click)="displayBillsList()">
          <div class="selected-bill-desc">
            {{ selectedBill.period }}
          </div>
          @if (this.bills.length > 1 && (selectedProcedure == null || selectedProcedure == '')) {
            <div class="change-bill-select">
              <span class="change-bill-select_txt">Changer de facture</span>
              @if (bills.length > 1) {
                <img src="../../../../../assets/images/icons/{{ arrowImage }}.png">
              }
            </div>
          }
        </div>
      </div>
    }
    <app-modal-bills-list [bills]="bills" [visibility]="visibility"></app-modal-bills-list>
    @if (bills.length > 0) {
      <div class="tabs-area icon-tab bill-details-{{ brand }}" >
        <nav class="pb-3">
          <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
            <a class="nav-item nav-link left-border-tab {{ billsTab }}" (click)="setActiveTab('liste', false)" id="nav-list-tab" data-toggle="tab" href="#nav-list" role="tab" aria-controls="nav-list" aria-selected="true">MES FACTURES</a>
            <a class="nav-item nav-link left-border-tab right-border-tab {{ billManagementTab }}" (click)="setActiveTab('gestion', false)" id="nav-management-tab" data-toggle="tab" href="#nav-management" role="tab" aria-controls="nav-management">GESTION DE MES FACTURES</a>
            @if (notificationsPaginator?.data?.length > 0) {
              <a class="nav-item nav-link right-border-tab {{ notificationsTab }}" (click)="setActiveTab('notifications', false)" id="nav-notifications-tab" data-toggle="tab" href="#nav-notifications" role="tab" aria-controls="nav-notifications" aria-selected="false">NOTIFICATIONS
                <app-notif-bell [notificationsNumber]="notificationsPaginator?.totalUnread"></app-notif-bell>
              </a>
            }
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show {{ billsTab }}" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
            <div class="card">
              <div class="card-body card-body-without-padding">
                <div class="bills-grid w-100">
                  <div class="col-12 p-3">
                    <div class="pb-3 bill-id">
                      <span class="bold-label-text mr-3">Numéro: </span><em>{{ selectedBill.id }}</em>
                    </div>
                    <div class="bill-amount pb-3">
                      <span class="bold-label-text mr-3">Montant de ma facture:</span><em>{{ priceFormatService.getBillAmount(selectedBill.totalTtc, selectedBill.totalHt, selectedBill.cusPenalityHt) }}</em>
                    </div>
                    @if (selectedBill.cusPenalityHt > 0) {
                      <div class="bill-amount pb-3">
                        <span class="bold-label-text mr-3">Pénalité de retard: </span><em>{{ selectedBill.cusPenalityHt }}€</em>
                      </div>
                    }
                    @if (firstBill.dueTtc != 0) {
                      <div class="bill-amount">
                        @if (firstBill.dueTtc > 0) {
                          <div class="pb-3">
                            <span class="bold-label-text mr-3">Montant dû au {{ firstBill.date }}:</span><em>{{ priceFormatService.get(firstBill.dueTtc.toString()) }}</em>
                          </div>
                        }
                        @if (firstBill.dueTtc < 0) {
                          <div class="pb-3">
                            <span class="bold-label-text mr-3">Solde en votre faveur:</span><em>{{ priceFormatService.get(firstBill.dueTtc.toString()) }}</em>
                          </div>
                        }
                        @if ((firstBill.totalTtc + firstBill.dueTtc) > 0) {
                          <div>
                            <span class="bold-label-text mr-3">Total:</span><em>{{ priceFormatService.getBillAmount(firstBill.totalTtc, firstBill.totalHt, 0, firstBill.dueTtc) }}</em>
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-12 align-self-center text-center">
                    <br />
                    <button type="button" class="cta_btn level_2" (click)="downloadBill()">Télécharger la facture<span></span></button>
                  </div>
                </div>
                @if (debitText != null && firstBill.id == selectedBill.id) {
                  <div class="ml-3 w-100 mb-3">
                    {{ debitText }}
                  </div>
                }
                @if ((bills.length > 1 && environment.data.brand == 'coriolis') || environment.data.brand !== 'coriolis') {
                  <hr>
                  }
                  @if ((bills.length > 1 && environment.data.brand == 'coriolis') || environment.data.brand !== 'coriolis') {
                    <div class="bills-grid w-100">
                      <div class="col-sm-12 col-md-11 col-xl-9 bold-label-text pb-3">
                        Télécharger le détail des communications :
                      </div>
                      <div class="col-sm-12 col-md-11 col-xl-9 text-center align-self-center pb-3 bill-download" style="margin-top: -10px;">
                        <button type="button" class="btn-outline-danger mr-5" (click)="sendBillDetailsRequest('pdf')">.pdf</button>
                        <button type="button" class="btn-outline-danger" (click)="sendBillDetailsRequest('xls')">.xls</button>
                      </div>
                    </div>
                  }
                </div>
              </div>
              @if (invoiceLifeCycle && invoiceLifeCycle.length > 0) {
                  <div [className]="'hr-'+environment.data.brand"></div>
                  <h2 class="bold-text mb-4">Historique:</h2>
                  @for (lifecycle of invoiceLifeCycle; track lifecycle; let index = $index) {
                      <table class="table table-striped border-top-0 invoice-lifecycle">
                          <tr>
                              <td width="60%">
                                  <div class="row mt-2">
                                      <div class="col-12">
                                          <strong>Description :</strong> {{ getReason(lifecycle) }}
                                      </div>
                                  </div>
                              </td>

                              <td>
                                  <div class="row mt-2">
                                      <div class="col-auto">
                                          <strong>État :</strong>
                                      </div>
                                      <div class="col-auto invoice-lifecycle-status">
                                          <app-dot [dynamicClass]="getStatusClassname(lifecycle.code)"></app-dot>
                                          <span class="invoice-lifecycle-label">{{ lifecycle.status }}</span>
                                      </div>
                                  </div>
                              </td>
                          </tr>
                          @if (lifecycle.description || lifecycle.note) {
                              <tr>
                                  <td colspan="2">
                                      <div class="row invoice-lifecycle-description">
                                          @if (lifecycle.description) {
                                              <div class="col-12">
                                                  <strong><u>Motif :</u></strong> {{ lifecycle.description }}
                                              </div>
                                          }
                                          @if (lifecycle.note) {
                                              <div class="col-12">
                                                  <strong><u>Note du client:</u></strong> <span [innerHTML]="formatNote(lifecycle.note)"></span>
                                              </div>
                                          }
                                      </div>
                                  </td>
                              </tr>
                          }
                      </table>
                  }
              }
            </div>
            <div class="tab-pane fade show {{ billManagementTab }}" id="nav-management" role="tabpanel" aria-labelledby="nav-management-tab">
              @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
                <div class="procedures-list">
                  <h2 class="mb-3">Actions en cours</h2>
                  @if ((null == selectedProcedure || '' == selectedProcedure) && inProgressProceduresList.length > 0) {
                    <div class="procedure-grid w-100 mb-4">
                      @for (procedure of inProgressProceduresList; track procedure) {
                        <div class="col-12" (click)="displayMessage(procedure)">
                          <app-procedure-card
                            [icon]="'icons/procedures/customer/'+procedure.code+'.png'"
                            [cursor]="true"
                            [text]="procedure.label"
                            [status]="procedure.status"
                          ></app-procedure-card>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if ((null == selectedProcedure || '' == selectedProcedure) && activeProceduresList.length > 0) {
                <div class="procedures-list">
                  <h2 class="mb-3">Actions disponibles</h2>
                  @if ((null == selectedProcedure || '' == selectedProcedure) && activeProceduresList.length > 0) {
                    <div class="procedure-grid w-100 mb-4">
                      @for (procedure of activeProceduresList; track procedure) {
                        <div class="col-12" (click)="getProcedure(procedure)">
                          <app-procedure-card [icon]="'icons/procedures/customer/'+procedure.code+'.png'" [cursor]="true" [text]="procedure.label"></app-procedure-card>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (constHelper.PROCEDURE_BILL_PROTEST == selectedProcedure && bills.length > 0) {
                <app-bill-protest [procedureCode]="selectedProcedure" [bills]="bills"></app-bill-protest>
              }
              @if (constHelper.PROCEDURE_EXPRESS_PAYMENT == selectedProcedure && ((amount && brand !== 'coriolis') || brand == 'coriolis')) {
                <app-payment-express [amount]="amount" [billId]="bills[0].id" [redirectLink]="null"></app-payment-express>
              }
              @if (constHelper.PROCEDURE_COMMUNICATION_DETAIL == selectedProcedure) {
                <app-communication-detail [procedureCode]="selectedProcedure"></app-communication-detail>
              }
            </div>
            @if (notificationsPaginator?.data?.length > 0) {
              <div class="tab-pane fade show {{ notificationsTab }}" id="nav-notifications" role="tabpanel" aria-labelledby="nav-notifications-tab">
                <app-notifications [notificationsPaginator]="notificationsPaginator" [type]="'bill'"></app-notifications>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (!selectedBill) {
    <div class="text-center mt-4 pt-3">Aucune facture n'est associée à ce compte.</div>
  }

  <app-frequently-questions [faq]="faqPageCode"></app-frequently-questions>
